// BETA-ONLY: Remove this feature when beta ends

import { useState, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../lib/firebase';
import type { BetaProfileFormData, SubmitBetaProfileResponse } from '../types/betaProfile';

/**
 * Hook for submitting the beta profile questionnaire.
 * Wraps the submitBetaProfileHttp Cloud Function.
 */
export function useSubmitBetaProfile(): {
  submit: (data: BetaProfileFormData) => Promise<SubmitBetaProfileResponse>;
  loading: boolean;
  error: string | null;
  reset: () => void;
} {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(
    async (data: BetaProfileFormData): Promise<SubmitBetaProfileResponse> => {
      setLoading(true);
      setError(null);

      try {
        const fn = httpsCallable<BetaProfileFormData, SubmitBetaProfileResponse>(
          functions,
          'submitBetaProfileHttp'
        );
        const result = await fn(data);
        return result.data;
      } catch (err) {
        const firebaseError = err as { code?: string };
        const errorMessage = firebaseError?.code === 'functions/resource-exhausted'
          ? "You're doing a lot! Please wait a moment and try again."
          : err instanceof Error ? err.message : 'Failed to save profile';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setLoading(false);
    setError(null);
  }, []);

  return { submit, loading, error, reset };
}
